import type { CSSProperties, ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { useReveal } from './useReveal'

export function Reveal({
  delay = 0,
  distance,
  className,
  children,
}: {
  delay?: number
  distance?: number
  className?: string
  children: ReactNode
}) {
  const ref = useReveal<HTMLDivElement>()
  const style = {
    ...(delay ? { '--reveal-delay': `${delay}ms` } : {}),
    ...(distance !== undefined ? { '--reveal-y': `${distance}px` } : {}),
  } as CSSProperties

  return (
    <div ref={ref} className={cn(className)} style={style}>
      {children}
    </div>
  )
}
